import React from 'react';
import {PlayerBrowseItem} from '@/features/players/api';
import PlayerBrowseCard from '../PlayerBrowseCard';
import {SquadLifecycleStatus} from '../PlayerBrowseTable';

interface PlayersGridProps {
  players: PlayerBrowseItem[];
  detailHref: (player: PlayerBrowseItem) => string;
  squadStatusById?: ReadonlyMap<string, SquadLifecycleStatus>;
  canManageWatchlist?: boolean;
  watchPending?: ReadonlySet<string>;
  onWatchChange?: (player: PlayerBrowseItem, next: boolean) => void;
}

const PlayersGrid: React.FC<PlayersGridProps> = ({players, detailHref, squadStatusById, canManageWatchlist, watchPending, onWatchChange}) => (
  <div className="space-y-3">
    {players.map(player => (
      <PlayerBrowseCard
        key={player.id}
        player={player}
        detailHref={detailHref(player)}
        squadStatus={squadStatusById?.get(player.id)}
        canManageWatchlist={canManageWatchlist}
        watchPending={watchPending}
        onWatchChange={onWatchChange}
      />
    ))}
  </div>
);

export default PlayersGrid;
